import {
  GET_CATEGORY_WISE_EXCEL_REPORT,
  GET_CATEGORY_WISE_EXCEL_REPORT_ERROR,
  GET_CATEGORY_WISE_EXCEL_REPORT_SUCCESS,
} from "../actions/auditAction";

const initialState = {
  auditExcelReportData: {},

  auditExcelReportLoading: false,
  auditExcelReportLoaded: false,
  auditExcelReportError: null,
};

export default function auditReducer(state = initialState, action) {
  switch (action.type) {
    case GET_CATEGORY_WISE_EXCEL_REPORT:
      return {
        ...state,
        auditExcelReportLoading: true,
        auditExcelReportLoaded: false,
        auditExcelReportError: null,
      };

    case GET_CATEGORY_WISE_EXCEL_REPORT_SUCCESS:
      return {
        ...state,
        auditExcelReportLoading: false,
        auditExcelReportLoaded: true,
        auditExcelReportData: action.payload.success,
      };

    case GET_CATEGORY_WISE_EXCEL_REPORT_ERROR:
      return {
        ...state,
        auditExcelReportLoading: false,
        auditExcelReportLoaded: false,
        auditExcelReportError: action.payload.error,
        auditExcelReportData: [],
      };

    default:
      return state;
  }
}
